import { requestGetRes, requestPostRes } from "../EdcService";

interface Result<Data> {
  code: number;
  message: string;
  success: boolean;
  data: Data
}

interface ListResult<T> {
  page: number;
  pageSize: number;
  total: number
  rows: T[]
}

export type SignAgreementResult = {
  agreement: string;
  allocationCode: unknown | null;
  centerCode: string;
  code: string;
  createTime: string;
  createUser: string;
  hasScreen: unknown | null;
  icon: string;
  id: number | null;
  joinDate: string;
  projectCode: string;
  state: number;
}

// 根据code查询签署模板信息
export const signAgreementQuery = (subjectCode: string, fromDoctor=false)=> {
  return requestGetRes(`data/subject/signAgreementQuery/${subjectCode}?judgment=${fromDoctor ? 1 : 2}`)
}

// 项目报表 - 入组数据报表（君实）
export type JoinProjectListResult = {
  createdTime: string
  createdUser: string
  finishTime: string
  id: number	
  projectCode: string
  taskName: string
  taskState: number
  url: string
}
export const getJoinProjectList = (projectCode: string, type: number, page: number, pageSize: number): Promise<Result<ListResult<JoinProjectListResult>>>=> {
  return requestPostRes('data/join/list', {
    projectCode,
    type,
    page,
    pageSize
  })
}

// 项目中心 - 项目报表 - 入组数据报表 新增
export const createJoinProjectTask = (projectCode: string): Promise<Result<any>>=> {
  return requestPostRes(`/data/join/task/${projectCode}`)
}
// 项目中心 - 项目报表 - 入组数据报表 新增
export const createMissedProjectTask = (projectCode: string): Promise<Result<any>>=> {
  return requestPostRes(`/data/loss/task/${projectCode}`)
}
// 项目中心 - 项目报表 - 数据缺失&质疑报表 新增
export const createMissedDataTask = (projectCode: string): Promise<Result<any>>=> {
  return requestGetRes(`data/question/dataMissing/${projectCode}`)
}
// 项目中心 - 项目报表 - 结算报表 新增
export const createAccountJoinTask = (projectCode: string): Promise<Result<any>>=> {
  return requestPostRes(`data/join/account/export/${projectCode}`)
}
// 项目中心 - 项目报表 - 访视进度报表 新增
export const creatJoinVisitTask = (projectCode: string): Promise<Result<any>>=> {
  return requestPostRes(`data/join/visit/export/${projectCode}`)
} 

export interface SumCountRecord {
  allCount: number
  groupNum: number
  questionNum: number
}
export const getSumCount = (): Promise<Result<SumCountRecord>>=> {
  return requestPostRes('data/getSumCount')
}

// 汉字转拼音
export const getAbbreviation = (name: string): Promise<Result<string>> => {
  return requestGetRes(`data/subejct/name/abbreviation?name=${name}`)
}

// 撤回锁定
export const unlockForm = (formId: number)=> {
  return requestGetRes(`data/form/unlock/${formId}`)
}

// 查询表单访视名称
interface TreeResult {
  visitId: number
  visitName: string
  formNames: {
    formId: number
    formName: number
  }[]
}
export const getVisitTree = (subjectCode: string): Promise<Result<TreeResult[]>>=> {
  return requestGetRes(`data/visit/formData/${subjectCode}`)
}

// 获取表单预设单位和范围值
export const fillInFormPre = (formId: number)=> {
  return requestPostRes(`data/fillIn/formPre/${formId}`)
}